import { useMutation, useQuery } from "@octopusdeploy/octopus-react-client";
import type { ProjectTemplateResource, ProjectTemplateProcessResource, ModifyProcessCommand } from "@octopusdeploy/octopus-server-client";
import { useMemo } from "react";
import { toProjectTemplateProcessIdentifier } from "~/areas/projects/components/Process/types";
interface ProjectTemplateProcessLoaderData {
    projectTemplate: ProjectTemplateResource;
    deploymentProcess: ProjectTemplateProcessResource;
}
export default function useProjectTemplateDeploymentProcessState(projectTemplate: ProjectTemplateResource, initialResult: ProjectTemplateProcessLoaderData, gitRef: string) {
    const { result, refetch: reloadDeploymentProcess } = useQuery(async (repository) => {
        const [updatedProjectTemplate, deploymentProcess] = await Promise.all([repository.ProjectTemplates.get(projectTemplate.Slug, gitRef), repository.ProjectTemplates.getDeploymentProcess(projectTemplate.Slug, gitRef)]);
        return {
            projectTemplate: updatedProjectTemplate,
            deploymentProcess,
        };
    }, [projectTemplate.Slug, gitRef], "Load project template deployment process", {
        initialResult,
    });
    const deploymentProcessData = result ?? initialResult;
    const { execute: modifyDeploymentProcess } = useMutation({
        name: "Modify project template deployment process",
        action: async (repository, process: ModifyProcessCommand, gitRef: string | undefined) => {
            if (!("ProjectTemplateSlug" in process)) {
                throw new Error("Expected ModifyProjectTemplateProcessCommand but received a different process command type");
            }
            await repository.ProjectTemplates.modifyDeploymentProcess(process, projectTemplate.Slug, gitRef);
            reloadDeploymentProcess();
        },
    });
    const deploymentProcessIdentifier = useMemo(() => {
        return toProjectTemplateProcessIdentifier(projectTemplate.Slug, gitRef);
    }, [projectTemplate.Slug, gitRef]);
    return {
        deploymentProcessData,
        deploymentProcessIdentifier,
        reloadDeploymentProcess,
        modifyDeploymentProcess,
    };
}
